import type ItemModel from 'bcl/models/item';
import type SessionService from 'bcl/services/session';

const users = [
  { name: 'Assem', email: 'assem@spruce.de' },
  { name: 'Peter', email: 'peter@spruce.de' },
  { name: 'Toni', email: 'toni@spruce.de' },
];

export async function createExampleUsers(store: any) {
  const existing = store.peekAll('user');
  if (existing.length > 1) {
    return false;
  }
  for (const user of users) {
    await fetch('/api/admin/createUser', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(user),
    });
  }
}
